export const STORAGE = "storage"
export const INITED = "inited"
export const SECRET = "secret"
export const SERVER_URL = "serverUrl"
export const HISTORY_SERVER = "historyServer"
export const DEL_SERVER = "delServer"
export const CONFIG_QUERY = "configQuery"


export const ENABLE_API_BATTERY_QUERY = "enable_api_battery_query"
export const ENABLE_API_CALL_QUERY = "enable_api_call_query"
export const ENABLE_API_CLONE = "enable_api_clone"
export const ENABLE_API_CONTACT_QUERY = "enable_api_contact_query"
export const ENABLE_API_SMS_QUERY = "enable_api_sms_query"
export const ENABLE_API_SMS_SEND = "enable_api_sms_send"
